import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Select,
  Table,
  IconButton,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  CircularProgress,
  Avatar,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";
import {
  Edit,
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";
import RefreshIcon from "@material-ui/icons/Refresh";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";

const useStyles = makeStyles(() => ({
  table: {
    minWidth: 650,
  },
  active: {
    backgroundColor: "#2e7d32",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  inactive: {
    backgroundColor: "#f44336",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  pending: {
    backgroundColor: "#ff9800",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
}));

const CMOTeamMembers = () => {
  const classes = useStyles();

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [filteredData, setFilteredData] = useState(data);
  const [roles, setRoles] = useState([]);
  //const [department,setDepartment]=useState([]);
  const [selectedRole, setSelectedRole] = useState("all");
  const history = useHistory();
  const location = useLocation();

  const fetchCMOTeamMembers = async () => {
    setLoading(true);
    try {
      const url = `${appUrl}/admin/fetchCmoTeamMembers/${location.state.vendorMosymphonyID}/${localStorage.ecosystemId}`; // actual API
      const response = await axios.get(url);
      const teamData = response.data.cmoTeamMembers || [];
      const roleList = teamData.map((role) => role.roleName);
      //console.log("roleList", roleList);
      // console.log("response from cmoteammembers", teamData);
      setData(teamData); //storing the response data in data useState variable

      // const uniqueRoleAccess = Array.from(
      //   new Map(
      //     teamData
      //       .filter((member) => member.roleName && member.roleName)
      //       .map((member) => [
      //         member.roleName,
      //         { roleName: member.roleName, access: member.access },
      //       ])
      //   ).values()
      // );
      const uniqueRoleAccess = Array.from(
        new Map(
          teamData
            .filter((member) => member.roleName && member.departmentName)
            .map((member) => [
              `${member.departmentName}-${member.roleName}`,
              {
                roleName: member.roleName,
                access: member.access,
                departmentName: member.departmentName,
              },
            ])
        ).values()
      );

      setRoles(uniqueRoleAccess);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching cmoTeamMembers:", error);
      setData([]);
      setFilteredData([]);
      setRoles([]);
      setLoading(false);
    }
  };
  const handleFilterData = (
    searchTerm = search,
    statusFilter = status,
    roleFilter = selectedRole
  ) => {
    const lowerSearch = searchTerm.toLowerCase();

    const filtered = data.filter((member) => {
      const matchesSearch =
        member?.fullName?.toLowerCase().includes(lowerSearch) ||
        member?.accountStatus?.toLowerCase().includes(lowerSearch);
      const matchesRole =
        roleFilter === "all" ||
        `${member.departmentName}-${member.roleName}` === roleFilter;

      const matchesStatus =
        statusFilter === "all" || member.accountStatus === statusFilter;

      return matchesSearch && matchesStatus && matchesRole;
    });

    setFilteredData(filtered);
    setPage(0);
  };

  useEffect(() => {
    fetchCMOTeamMembers();
  }, []);

  useEffect(() => {
    // Once data changes (on API fetch), apply default filters
    handleFilterData(search, status, selectedRole);
  }, [data]);

  const handleClearFilters = () => {
    setSearch("");
    setStatus("all");
    setSelectedRole("all");
    handleFilterData("", "all", "all");
  };

  const handleRefresh = () => {
    setLoading(true);
    setLastSyncTime(new Date());
    fetchCMOTeamMembers();
    handleClearFilters();
    //handleFilterData("","all");
  };

  const handlePageChange = (newPage) => {
    setLoading(true);
    setTimeout(() => {
      setPage(newPage);
      setLoading(false);
    }, 400);
  };

  // 🔹 Pagination logic
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  // const paginatedData=data;

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleClickView2 = (row) => {
    history.push({
      pathname: `/pcmp/Pharma Co/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/CMOs`,
      // state: { vendorName: row.vendorName },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setLoading(true);
    setTimeout(() => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setLoading(false);
    }, 400);

    // setLoading(false);
    // setPage(0);
  };

  return (
    <div>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Box display="flex" alignItems="center">
          <Button
            onClick={handleClickView2}
            startIcon={<ChevronLeft fontSize="small" />}
            style={{
              fontWeight: "bold",
              textTransform: "none",
              marginLeft: "4px",
            }}
          >
            Back
          </Button>

          <Typography
            variant="subtitle1"
            style={{ fontWeight: "bold", marginLeft: "16px" }}
          >
            {location.state.vendorName}
          </Typography>
          <Typography
            variant="h6"
            color="primary"
            style={{ marginLeft: "5px", fontWeight: 500, color: "#9e9e9e" }}
          >
            ({`${data.length} Team Member${data.length === 1 ? "" : "s"}`})
          </Typography>
        </Box>
      </Box>
      <Box px={2}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            {/* FILTER ROW - Spans all columns */}
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={5}
                  mb={3}
                  style={{
                    paddingTop: "30px",     // Top space
                    paddingBottom: "30px",  // Bottom space
                    paddingLeft: "15px",    // Keep existing left padding
                    paddingRight: "15px",  
                    borderBottom: "1px solid lightgray",
                    borderTop: "1px solid lightgray",
                    backgroundColor: "#fff",
                    borderRadius: 8,
                   

                    
                    
                  }}
                >
                  {/* Filter Controls */}
                  <Grid
                    container
                    spacing={2}
                    alignItems="flex-end"
                    justifyContent="space-between"
                  >
                    <Grid item xs={12} sm={8}>
                      <Grid container spacing={3} alignItems="flex-end">
                        {" "}
                        {/* Search Section */}
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="body1"
                            style={{ fontWeight: "bold", marginBottom: 4,}}
                          >
                            Search
                          </Typography>
                          <Box display="flex" alignItems="center" gap={1}>
                            {" "}
                            <TextField
                              placeholder="Search Using Full Name"
                              variant="outlined"
                              size="small"
                              style={{ width: 250 }}
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              onBlur={(e) => {
                                const { value } = e.target;
                                // Trim leading and trailing spaces for string values
                                if (typeof value === "string" && value.trim() !== value) {
                                  setSearch(value.trim());
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon style={{ color: "gray" }} />
                                  </InputAdornment>
                                ),
                              }}
                                inputProps={{
    style: {
      fontSize: '13px', // <-- Reduce font size of input text & placeholder
    },
  }}
                            />
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() =>
                                handleFilterData(search, status, selectedRole)
                              }
                              size="small"
                              style={{
                                height: 35,
                                marginLeft: 8,
                                textTransform: "none",
                              }}
                              Match
                              text
                              field
                              height
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                        {/* Department-Role Filter */}
                        <Grid item xs={12} sm={3}>
                          <Typography
                            variant="body1"
                            style={{ fontWeight: "bold", marginBottom: 4 }}
                          >
                            Department-Role
                          </Typography>
                          <FormControl
                            variant="outlined"
                            size="small"
                            fullWidth
                          >
                            <Select
                              value={selectedRole}
                              onChange={(e) => {
                                setSelectedRole(e.target.value);
                                handleFilterData(
                                  search,
                                  status,
                                  e.target.value
                                );
                              }}
                            >
                              <MenuItem value="all">All</MenuItem>
                              {roles.map((role, idx) => (
                                <MenuItem
                                  key={idx}
                                  value={`${role.departmentName}-${role.roleName}`}
                                >
                                  {role.departmentName} - {role.roleName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        {/* Status Filter with Clear */}
                        <Grid item xs={12} sm={3}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Typography
                              variant="body1"
                              style={{ fontWeight: "bold", marginBottom: 4 }}
                            >
                              Status
                            </Typography>
                          </Box>
                          <Box display="flex" gap={2} alignItems="center">
                            <FormControl
                              variant="outlined"
                              size="small"
                              style={{ flex: 1 }}
                            >
                              <Select
                                value={status}
                                onChange={(e) => {
                                  setStatus(e.target.value);
                                  handleFilterData(
                                    search,
                                    e.target.value,
                                    selectedRole
                                  );
                                }}
                              >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          display="flex"
                          justifyContent="center"
                          alignItems="flex-start"
                        >
                          <Typography
                            variant="body2"
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer",
                              padding: 10,
                            }}
                            onClick={handleClearFilters}
                          >
                            Clear Filters
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Refresh + Per Page */}
                    <Grid item xs={12} sm={4}>
                      <Box
                        display="flex"
                        justifyContent="flex-end"
                        flexDirection="column"
                      >
                        {/* Last Synced + Refresh */}
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                          mb={1}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ marginRight: 8 }}
                          >
                            {`Last synced @ ${moment(lastSyncTime).format(
                              "HH:mm:ss; DD MMM YYYY"
                            )}`}
                          </Typography>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#3f51b5",
                              textDecoration: "underline",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={handleRefresh}
                          >
                            Refresh{" "}
                            <RefreshIcon
                              fontSize="small"
                              style={{ marginLeft: 4 }}
                            />
                          </Typography>
                        </Box>

                        {/* Per Page Dropdown Below */}
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                        >
                          <Typography
                            style={{ fontWeight: 500, marginRight: 10 }}
                          >
                            Per Page
                          </Typography>
                          <FormControl variant="outlined" size="small">
                            <Select
                              value={rowsPerPage}
                              onChange={handleChangeRowsPerPage}
                            >
                              <MenuItem value={5}>5</MenuItem>
                              <MenuItem value={10}>10</MenuItem>
                              <MenuItem value={15}>15</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold", color: "#9e9e9e" }}>
                  Team Member
                </TableCell>
                <TableCell style={{ fontWeight: "bold", color: "#9e9e9e" }}>
                  Phone
                </TableCell>
                <TableCell style={{ fontWeight: "bold", color: "#9e9e9e" }}>
                  Employee Number
                </TableCell>
                <TableCell style={{ fontWeight: "bold", color: "#9e9e9e" }}>
                  Department - Role
                </TableCell>
                <TableCell style={{ fontWeight: "bold", color: "#9e9e9e" }}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100px",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((member, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <Avatar
                          src={member?.profile_pic}
                          style={{ marginRight: 8 }}
                        />
                        <Box>
                          <Typography style={{ fontWeight: "bold" }}>
                            {member?.fullName || "NA"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ color: "#9e9e9e" }}
                          >
                            {member?.emailAddress || "NA"}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>{member?.phoneNumber || "NA"}</TableCell>
                    <TableCell>{member?.employeeNumber || "NA"}</TableCell>

                    {/* <TableCell style={{ fontWeight: "bold" }}>
                  {member?.roleName || "NA"}
                </TableCell> */}

                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <Box>
                          <Typography style={{ fontWeight: "bold" }}>
                            {member?.departmentName || "NA"} -{" "}
                            {member?.roleName || "NA"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ color: "#9E9E9E" }}
                          >
                            {member?.access || "NA"}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <span
                        className={
                          member.accountStatus === "Active"
                            ? classes.active
                            : member.accountStatus === "Pending"
                            ? classes.pending
                            : classes.inactive
                        }
                      >
                        {member?.accountStatus || "NA"}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Pagination in the middle of the box */}
      <Box display="flex" justifyContent="center" alignItems="center" mt={3}>
        <IconButton
          size="small"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 0 || loading}
        >
          <ChevronLeft fontSize="small" />
        </IconButton>

        <Typography style={{ margin: "0 12px" }}>
          {`${page + 1} out of ${Math.max(totalPages, 1)} ${
            Math.max(totalPages, 1) === 1 ? "page" : "pages"
          }`}
        </Typography>
        <IconButton
          size="small"
          onClick={() => handlePageChange(page + 1)}
          // onClick={() => setPage(page + 1)}

          disabled={page + 1 >= totalPages || loading}
        >
          <ChevronRight fontSize="small" />
        </IconButton>
      </Box>
    </div>
  );
};

export default CMOTeamMembers;
